const isEstimatedTradeIn = (tradeInData) => {
    const {expired = false, firstTradeMode = "", dsOfferedPrice = 0, makeModelFlow = false} = tradeInData || {};
    return !expired && ((firstTradeMode === "BANNER" && dsOfferedPrice && !makeModelFlow));
};

export default isEstimatedTradeIn;
